const PackageIcon = ({ active }) => {
  const fillColor = active ? "#1E1E1E" : "#969696";
  return (
    <svg
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_217_5849)">
        <path
          d="M11.6667 0H2.33333C1.0465 0 0 1.0465 0 2.33333V2.91667C0 3.4335 0.22575 3.899 0.583333 4.21983V11.0833C0.583333 12.6916 1.89175 14 3.5 14H5.25C5.572 14 5.83333 13.7387 5.83333 13.4167C5.83333 13.0947 5.572 12.8333 5.25 12.8333H3.5C2.53517 12.8333 1.75 12.0482 1.75 11.0833V4.66667H12.25V5.25C12.25 5.572 12.5113 5.83333 12.8333 5.83333C13.1553 5.83333 13.4167 5.572 13.4167 5.25V4.21983C13.7742 3.899 14 3.43408 14 2.91667V2.33333C14 1.0465 12.9535 0 11.6667 0ZM1.75 3.5C1.42858 3.5 1.16667 3.23808 1.16667 2.91667V2.33333C1.16667 1.68992 1.68992 1.16667 2.33333 1.16667H11.6667C12.3101 1.16667 12.8333 1.68992 12.8333 2.33333V2.91667C12.8333 3.23808 12.5714 3.5 12.25 3.5H1.75ZM9.91667 5.83333C7.665 5.83333 5.83333 7.665 5.83333 9.91667C5.83333 12.1683 7.665 14 9.91667 14C12.1683 14 14 12.1683 14 9.91667C14 7.665 12.1683 5.83333 9.91667 5.83333ZM9.91667 12.8333C8.30842 12.8333 7 11.5249 7 9.91667C7 8.30842 8.30842 7 9.91667 7C11.5249 7 12.8333 8.30842 12.8333 9.91667C12.8333 11.5249 11.5249 12.8333 9.91667 12.8333ZM11.7956 9.20967C12.019 9.44183 12.0114 9.81108 11.7787 10.0345L10.4883 11.2735C10.2241 11.5342 9.87467 11.6649 9.52408 11.6649C9.1735 11.6649 8.82175 11.5342 8.55342 11.2717L7.89308 10.626C7.66267 10.4002 7.65917 10.031 7.88433 9.80058C8.11067 9.57133 8.47992 9.56725 8.70975 9.79183L9.37008 10.4382C9.45408 10.5216 9.59058 10.5204 9.67458 10.4382L10.9713 9.19333C11.2035 8.96992 11.5728 8.9775 11.7962 9.21025L11.7956 9.20967Z"
          fill={fillColor}
        />
      </g>
      <defs>
        <clipPath id="clip0_217_5849">
          <rect width="14" height="14" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default PackageIcon;
